import React from 'react';

import { ScrollView } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';
import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { ActionsheetContent, ActionsheetWrapper } from 'components/action-sheet';
import Dialog from 'components/dialog';
import { useIsDesktopWebBreakpoint } from 'hooks/use-media-query';
import { primitive } from 'styles/constants/primitives';
import { routes } from 'utils/routing';

import { Body, Container, Header, Text } from './styled';
import { DismissPromptProps } from './types';

export const DismissPrompt = ({ isOpen, onClose }: DismissPromptProps) => {
  const isDesktopWeb = useIsDesktopWebBreakpoint();
  const { formatMessage } = useIntl();
  const router = useRouter();

  const eventMessage = 'Store locator close prompt';

  const content = (
    <Container>
      <Body paddingX={isDesktopWeb ? '$0' : '$2'}>
        <Header>{formatMessage({ id: 'storeLocatorClosePromptHeading' })}</Header>
        <Text>{formatMessage({ id: 'storeLocatorClosePromptBody' })}</Text>
      </Body>
      <ScrollView showsVerticalScrollIndicator={isDesktopWeb}>
        <ActionButton onPress={onClose}>{formatMessage({ id: 'selectStore' })}</ActionButton>
        <ActionButton
          marginTop="$4"
          variant={ActionButtonVariants.OUTLINE_V2}
          onPress={() => router.replace(routes.base)}
          _hover={{ _text: { color: primitive.$white } }}
        >
          {formatMessage({ id: 'goToHomepage' })}
        </ActionButton>
      </ScrollView>
    </Container>
  );

  return isDesktopWeb ? (
    <Dialog
      showDialog={isOpen}
      modalAppearanceEventMessage={eventMessage}
      contentMaxWidth="520px"
      onDismiss={onClose}
      bodyComponent={content}
      closeOnOverlayClick
      contentPadding="$4"
    />
  ) : (
    <ActionsheetWrapper onOpenEventMessage={eventMessage} isOpen={isOpen} onClose={onClose}>
      <ActionsheetContent padding={0} alignItems="stretch">
        {content}
      </ActionsheetContent>
    </ActionsheetWrapper>
  );
};
